$(document).ready(function(){
  const container = $('#build-a-bundles');
  const sections = container.find('[js-build-section]');
  let selectedProducts = [];
  let packQuantityCount = 0;
  let urlL = container.find('[js-collection]')[0]

  let collectionTUrl = `${window.location.origin}${$(urlL).data('collectionUrl')}?view=pack_ajax`
  // header section script start
  console.log({collectionTUrl})
  container.find('[js-header-menu-item]').click(function(){
    const index = $(this).index();
    sectionMove(this, 'index', index)
  })
  container.find('[js-builder-previous-arrow]').click(function(){
    const index = container.find('.active[js-build-section]').prev().index() - 1;
    sectionMove(this, 'index', index)
  })
  // header section script end

  // first section script start
  /*
    container.find('[js-build-collection-list]').click(function(){
      const collectionsName = $(this).data('collectionsName');
      selectedtag(this, container.find('[js-build-collection-list]'), 'active');
      const nextSection = sectionMove(this, 'next')
      $(nextSection).find(`[js-collections-list-wrapper]`).hide();
      $(nextSection).find(`[data-collections-name='${collectionsName}']`).show();
      $(nextSection).find(`[data-media]`).hide();
      $(nextSection).find(`[data-media='${collectionsName}']`).show();
      selectedProducts = [];
      createReviewBundleSection(selectedProducts);
      createPackBox(packQuantityCount, selectedProducts);
    })
    */
  // first section script end

  // First section script start
  container.find('[js-collection]').click(function(){
    const blockId = $(this).data('block-id');
    const collectionUrl = $(this).data('collectionUrl');
    selectedtag(this, container.find('[js-collection]'), 'active');
    // const nextSection = sectionMove(this, 'next');
    // $(nextSection).find(`[data-media-id]`).hide();
    // $(nextSection).find(`[data-media-id='${blockId}']`).show();
    const url = `${window.location.origin}${collectionUrl}?view=pack_ajax`
    collectionTUrl = url
    console.log({url});
    
    
  })
  // First section script end

  // third section script start 
  container.find('[js-pack-quantity]').click(function(){
    const packQuantity = $(this).data('packQuantity');

    const packPrice = $(this).data('packPrice');
    $('[js-add-to-cart-btn-price]').html(packPrice);

    packQuantityCount = parseInt(packQuantity);
    container.find('[js-pack-quanity-total-count]').text(packQuantityCount);
    selectedtag(this, container.find('[js-pack-quantity]'), 'active');
    sectionMove(this, 'next')

    container.find('[js-build-section]').hide()
    container.find('.section-3').show()
    
    getData(collectionTUrl, '[js-collection-products]', '[js-collection-products]')
    selectedProducts = [];
    createReviewBundleSection(selectedProducts);
    createPackBox(packQuantityCount, selectedProducts);

    container.find('.bl-review-wrapper').show()
    container.find('.bl-review-wrapper').show()



  })
  // third section script end

  // forth section script start
  container.find('[js-select-product-btn]').click(function(){

    if(!container.find('.selected[js-color-option]').hasClass('soldout')){
      const selectedVariant = container.find('.selected[js-color-option]').data('variantId');
      const selectedOptionName = container.find('.selected[js-color-option]').data('optionName');
      const selectedVariantImage = container.find('.selected[js-color-option]').data('variant-url');
      const selectedProductTitle = container.find('.selected[js-product]').data('productTitle');
  
      if(selectedVariant && selectedVariantImage){
        selectedProducts.push({
          id: parseInt(selectedVariant),
          imageUrl: selectedVariantImage,
          productTitle: selectedProductTitle,
          optionName: selectedOptionName,
        })
      } else {
        container.find('[js-notification-wrapper]').show();
        setTimeout(() => {
          container.find('[js-notification-wrapper]').hide();
        }, 3000)
      }
  
      createPackBox(packQuantityCount, selectedProducts);
    }
    
  })

  container.find('[js-filled-pack-box-btn]').click(function(){
    sectionMove(this, 'next')
    createReviewBundleSection(selectedProducts);
  })
  // forth section script end

  // fifth section script start
  container.find('[js-add-to-cart-btn]').click(function(){
    $(this).addClass('btn--loading');
    const data = [];

    selectedProducts.forEach(item => {
      let exist = data.find(variant => variant.id === item.id);

      if(!exist){
        data.push({
          id: item.id,
          quantity: 1,
        })
      } else {
        data.forEach((item_, index) => {
          if(exist.id === item_.id){
            data[index].quantity += 1
          }
        });
      }
      
    })

    const _self = this;

    $.post('/cart/add.js', 
    {
      items: data
    }, 
    function(e){
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      
      setTimeout(() => {
        $('.cart__checkout').click()
        $(_self).removeClass('btn--loading');
      }, 1000)
      
    });

    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      
      setTimeout(() => {
        $('.cart__checkout').click()
        $(_self).removeClass('btn--loading');
      }, 1000)
      
    }, 2500)

  });
  // fifth section script end

  function createReviewBundleSection(selectedProducts_){

    const reviewBundleWrapper = container.find('[js-review-bundle-wrapper]');
    reviewBundleWrapper.html('');

    for(let item = 0; item < selectedProducts_.length; item++){
      reviewBundleWrapper.append(
        `<div class="bl-review-box" js-review-bundle-box>
            <div class="bl-review-left">
                <div class="bl-review-image">
                    <img src="${selectedProducts_[item].imageUrl}">
                </div>
                <div class="bl-review-content">
                    <h5 class="bl-review-sub-title">${selectedProducts_[item].productTitle}</h5>
                    <div class="bl-review-option bl-review-size">Color: ${selectedProducts_[item].optionName}</div>
                </div>
            </div>
            <div class="bl-review-box-button" js-remove-variant-btn >Reselect</div>
        </div>`);
    }

    removeVariant();
    
  }

  function createPackBox(packQuantityCount_, selectedProducts_){
    let boxFilledCount = selectedProducts_.length + 1;
    const selectionProductsBoxWrapper = container.find('[js-selection-products-box-wrapper]');
    selectionProductsBoxWrapper.html('');

    for(let item = 0; item < selectedProducts_.length; item++){
      console.log(selectedProducts_[item])
      selectionProductsBoxWrapper.append(
        `<div class="bottom-slide-box" js-selection-products-box js-variant-id="${selectedProducts_[item].id}" >
          <span class="remove-variant-btn" js-remove-variant-btn >
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
              <path d="M4 7L4 1" stroke="#1F4B7F" stroke-linecap="round"/>
              <path d="M7 4L1 4" stroke="#1F4B7F" stroke-linecap="round"/>
            </svg>
          </span>
          <div class="image">
            <img src="${selectedProducts_[item].imageUrl}">
          </div>
        </div>`);
    }

    for(boxFilledCount; boxFilledCount <= packQuantityCount_; boxFilledCount++){
      selectionProductsBoxWrapper.append(
        `<div class="bottom-slide-box" js-selection-products-box>
          <div class="image"></div>
        </div>`);
    }

    container.find('[js-pack-quanity-count]').text(selectedProducts_.length);
    

    if(selectedProducts_.length === packQuantityCount_){
      container.find('[js-select-product-btn]').hide()
      container.find('[js-filled-pack-box-btn]').show()
      container.find('[js-add-to-cart-btn]').show()
      container.find('[js-pack-quanity-count-title]').text(selectedProducts_.length);
    } else {
      container.find('[js-filled-pack-box-btn]').hide()
      container.find('[js-add-to-cart-btn]').hide()
      container.find('[js-select-product-btn]').show()
      container.find('[js-pack-quanity-count-title]').text(selectedProducts_.length + 1);
    }

    removeVariant();

  }

  function removeVariant(){
    container.find('[js-remove-variant-btn]').click(function(){
      const parent = $(this).parents('[js-build-section]');
      
      let index = null;

      if(parent.hasClass('bl-review-bundle')){
        index = $(this).parents('[js-review-bundle-box]').index();
        sectionMove(this, 'prev')
      } else {
        index = $(this).parents('[js-selection-products-box]').index();
      }

      selectedProducts.splice(index, 1);
      createPackBox(packQuantityCount, selectedProducts);
      
    })
  }

  function selectedtag(_self, list, className){
    list.removeClass(className);
    $(_self).addClass(className);
  }

  function getData(url, ajaxSelector, currentSelector){
      console.log("url in getData", url)
    fetch(url).then(function(response) {
      return response.text();
    }).then(function(html) {
      // Convert the HTML string into a document object
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const ajaxSelector_ = $(doc).find(ajaxSelector);

      container.find(currentSelector).html(ajaxSelector_.children())

      if(!url.includes('/collections/')){

        const ajaxSliderWrapper = $(doc).find('[js-slider-wrapper]');
        const currentSliderWrapper = container.find('[js-slider-wrapper]');
        const ajaxProductTitleWrapper = $(doc).find('[js-product-title]');
        const currentProductTitleWrapper = container.find('[js-product-title]');
        currentProductTitleWrapper.html(ajaxProductTitleWrapper.text())
        currentSliderWrapper.html(ajaxSliderWrapper.children())
        // buildSlider();
        selectOption();
        container.find('[js-current-color-option-name]').html($('.selected[js-color-option]').data('option-name'));

      } else {

        const firstProduct = container.find(currentSelector).find('[js-product]')[0];
        const firstProductUrl = $(firstProduct).data('productUrl');
        const productUrl = `${window.location.origin}${firstProductUrl}?view=pack_ajax`;
        getData(productUrl, '[js-product-color-option]', '[js-product-color-option]')
        selectedtag(firstProduct, container.find('[js-product]'), 'selected');


        container.find('[js-current-product-title]').html($(firstProduct).data('frame-name'));

      }
    
    });
  }

  function selectOption(){
    // fourth section script start
    container.find('[js-color-option]').click(selectSizeOption)
    function selectSizeOption(){
      selectedtag(this, container.find('[js-color-option]'), 'selected');
      container.find('[js-main-bundle-product-image]').attr('src', $(this).data('variant-url'));
      container.find('[js-current-color-option-name]').html($(this).data('option-name'));
    }

    container.find('[js-product]').click(selectProduct)

    function selectProduct(){
      let productUrl = $(this).data('productUrl');

      container.find('[js-current-product-title]').html($(this).data('frame-name'));

      productUrl = `${window.location.origin}${productUrl}?view=pack_ajax`;

      selectedtag(this, container.find('[js-product]'), 'selected');
      getData(productUrl, '[js-product-color-option]', '[js-product-color-option]')
      container.find('[js-product]').off('click', selectProduct)
    }
    // fourth section script end
  }

  function buildSlider(){
    var slider = new Swiper ('[js-main-product-slider]', {
      slidesPerView: 1,
      loop: true,
      centeredSlides: true,
      loopedSlides: 7,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  }

  function sectionMove(_self, option, index){

    container.find('[js-builder-previous-arrow]').show();
    if(index === 0){
      container.find('[js-builder-previous-arrow]').hide();
    }

    const parentSection = $(_self).parents('[js-build-section]');
    sections.hide();
    sections.removeClass('active');
    container.find('[js-header-menu-item]').removeClass('active');

    let currentHeaderItem = null;
    if(option === 'next'){

      
      const next = parentSection.next();
      next.addClass('active');
      const index_ = next.index() - 1;
      currentHeaderItem = container.find('[js-header-menu-item]')[index_];
      activateHeaderLink(currentHeaderItem);
      return next.show();

    } else if (option === 'prev'){

      const previous = parentSection.prev();
      previous.addClass('active');
      const index_ = previous.index() - 1;
      currentHeaderItem = container.find('[js-header-menu-item]')[index_];
      activateHeaderLink(currentHeaderItem);
      return previous.show();

    } else if (option === 'index'){

      currentHeaderItem = container.find('[js-header-menu-item]')[index];
      activateHeaderLink(currentHeaderItem);
      $(sections[index]).addClass('active');
      return $(sections[index]).show();

    }

    function activateHeaderLink(currentItem){
      $(currentItem).css({
        pointerEvents: 'auto'
      })
      $(currentItem).addClass('active');
    }

  }

})
